import { createSlice } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
enableMapSet();
const initialState = {
    isOrderSummaryLoading: false,
    isAddToWatchlistOpen: false,
    addToWatchlistPayload: undefined,
    buySellData: undefined,
    edisData: undefined,
    stockInfo: "",
    orderCancelData: undefined,
    cancelOrderDataStatus: false,
    // orderSummaryData: {},
    // edisData: { exchange: "N", exchangeType: "D", scripCode: 1, quantity: 1 },
    addToBasketPayload: undefined,
    createBasketVisibility: false,
    name: "",
    footerTabIds: new Set([]),
    closedComponent: "",
    selectedExpiry: [],
    openFooterTabId: undefined,
    momentumFullScreen: false,
    bulkOrderPlacement: undefined,
    // selectedExpiry: { data: [] },
    // handleButtonDisable: undefined,
    orderSummaryData: undefined,
    socketNotification: false,
    pledgeunpledgeModal: false,
    bulkOrderListData: [],
    summaryOrdersDataList: [],
    isGuestLoginModalOpen: false,
    updatedScripcodes: {
        scripCode_NIFTY: 0,
        scripCode_BANKNIFTY: 0,
    },
    stockList: { status: "", scripList: [] },
};
export const counterSlice = createSlice({
    name: "auth",
    initialState: initialState,
    reducers: {
        stockInfo: (state, action) => {
            state.stockInfo = action.payload;
        },
        onModalOpenClose: (state, action) => {
            const { componentName, currState } = action.payload;
            if (currState == "open") {
                state.footerTabIds.add(componentName);
            }
            else {
                state.closedComponent = componentName;
                state.footerTabIds.delete(componentName);
            }
        },
        openAddToWatchlistModal: (state, action) => {
            state.name = "watchlistModal";
            state.isAddToWatchlistOpen = true;
            state.addToWatchlistPayload = action.payload;
        },
        closeAddToWatchlistModal: (state) => {
            state.isAddToWatchlistOpen = false;
            state.addToWatchlistPayload = undefined;
        },
        openBuySellModal: (state, action) => {
            state.name = "buySellModal";
            state.buySellData = action.payload;
            // state.handleButtonDisable = action.payload?.handleButtonDisable;
        },
        closeBuySellModal: (state) => {
            // state.handleButtonDisable ? state.handleButtonDisable() : null;
            state.buySellData = undefined;
        },
        openOrderCancelModal: (state, action) => {
            state.name = "orderCancelModal";
            state.orderCancelData = action.payload;
        },
        closeOrderCancel: (state) => {
            state.orderCancelData = undefined;
        },
        openEdisModal: (state, action) => {
            state.edisData = action.payload;
        },
        closeEdisModal: (state) => {
            state.edisData = undefined;
        },
        openAddToBasketModal: (state, action) => {
            state.addToBasketPayload = action.payload;
            state.name = "addToBasket";
        },
        closeAddToBasketModal: (state) => {
            state.addToBasketPayload = undefined;
        },
        setCreateBasketVisibility: (state, action) => {
            state.createBasketVisibility = action.payload;
        },
        openSelectedExpiry: (state, action) => {
            state.selectedExpiry = action.payload;
            state.name = "selectedExpiry";
        },
        closeSelectedExpiry: (state) => {
            state.selectedExpiry = [];
        },
        openBulkOrderPlacement: (state, action) => {
            state.bulkOrderPlacement = action.payload;
        },
        closeBulkOrderPlacement: (state) => {
            state.bulkOrderPlacement = undefined;
        },
        openOrderSummary: (state, action) => {
            state.orderSummaryData = action.payload;
            state.name = "orderSummaryData";
        },
        setOrderSummary: (state, action) => {
            state.isOrderSummaryLoading = action.payload;
            state.name = "isOrderSummaryLoading";
        },
        closeOrderSummary: (state) => {
            state.orderSummaryData = undefined;
        },
        openFooterTab: (state, action) => {
            state.openFooterTabId = action.payload;
            state.name = "footerTabId";
        },
        openMomentumFullscreen: (state) => {
            state.momentumFullScreen = true;
            state.name = "momentumFullscreen";
        },
        closeMomentumFullscreen: (state) => {
            state.momentumFullScreen = false;
        },
        openSocketNotification: (state, action) => {
            state.socketNotification = action.payload;
        },
        openPledgeUnpledgeModal: (state) => {
            state.name = "pledgeUnpledge";
            state.pledgeunpledgeModal = true;
        },
        closePledgeUnpledgeModal: (state) => {
            state.pledgeunpledgeModal = false;
        },
        cancelOrderDataStatusReload: (state, action) => {
            state.cancelOrderDataStatus = action.payload;
        },
        setSummaryOrdersDataList: (state, action) => {
            state.summaryOrdersDataList = action.payload;
        },
        setBulkOrderDataList: (state, action) => {
            state.bulkOrderListData = action.payload;
        },
        openGuestLoginModal(state) {
            state.isGuestLoginModalOpen = true;
        },
        closeGuestLoginModal(state) {
            state.isGuestLoginModalOpen = false;
        },
        updateScripcodes(state, action) {
            const { scripCode_NIFTY, scripCode_BANKNIFTY } = action.payload;
            state.updatedScripcodes.scripCode_NIFTY = scripCode_NIFTY;
            state.updatedScripcodes.scripCode_BANKNIFTY = scripCode_BANKNIFTY;
        },
        setStockList(state, action) {
            state.stockList.status = action.payload.status;
            state.stockList.scripList = action.payload.scripList;
        },
    },
});
export const { openAddToWatchlistModal, closeAddToWatchlistModal, openBuySellModal, closeBuySellModal, openAddToBasketModal, closeAddToBasketModal, setCreateBasketVisibility, openEdisModal, closeEdisModal, onModalOpenClose, openOrderCancelModal, closeOrderCancel, stockInfo, openSelectedExpiry, closeSelectedExpiry, openOrderSummary, closeOrderSummary, openFooterTab, openMomentumFullscreen, closeMomentumFullscreen, openBulkOrderPlacement, closeBulkOrderPlacement, setOrderSummary, openSocketNotification, cancelOrderDataStatusReload, openPledgeUnpledgeModal, closePledgeUnpledgeModal, setSummaryOrdersDataList, setBulkOrderDataList, openGuestLoginModal, closeGuestLoginModal, updateScripcodes, setStockList } = counterSlice.actions;
export default counterSlice.reducer;
